import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { toProps } from '../../core';

function toCameraProps(_ref) {
  var far = _ref.far,
      fov = _ref.fov,
      lookControlsEnabled = _ref.lookControlsEnabled,
      near = _ref.near,
      reverseMouseDrag = _ref.reverseMouseDrag,
      wasdControlsEnabled = _ref.wasdControlsEnabled;
  return {
    far: far,
    fov: fov,
    'look-controls-enabled': lookControlsEnabled,
    near: near,
    'reverse-mouse-drag': reverseMouseDrag,
    'wasd-controls-enabled': wasdControlsEnabled
  };
}
/**
 * The camera primitive determines what the user sees.
 * We can change the viewport by modifying the camera entity’s position and rotation.
 *
 * @see https://aframe.io/docs/1.3.0/primitives/a-camera.html
 *
 * @example
 * ```tsx
 * <Scene>
 *   <Box />
 *   <Camera />
 * </Scene>
 * ```
 */


export default function Camera(props) {
  var cameraKeys = ['far', 'fov', 'lookControlsEnabled', 'near', 'reverseMouseDrag', 'wasdControlsEnabled'];
  var children = props.children;
  return /*#__PURE__*/React.createElement("a-camera", _extends({}, toProps(props, cameraKeys), toCameraProps(props)), children);
}